import { ToolRegistry } from '../../types/summarizer';
import { youtubeSummarizerConfig } from './youtube-summarizer';
import { pdfSummarizerConfig } from './pdf-summarizer';
import { textSummarizerConfig } from './text-summarizer';
import { videoSummarizerConfig } from './video-summarizer';
import { googleDocsSummarizerConfig } from './google-docs-summarizer';
import { podcastSummarizerConfig } from './podcast-summarizer';
import { webPageSummarizerConfig } from './web-page-summarizer';
import { twitterThreadSummarizerConfig } from './twitter-thread-summarizer';
import { powerpointSummarizerConfig } from './powerpoint-summarizer';
import { notionSummarizerConfig } from './notion-summarizer';
import { googleDriveSummarizerConfig } from './google-drive-summarizer';
import { audioFileSummarizerConfig } from './audio-file-summarizer';
import { socialMediaSummarizerConfig } from './social-media-summarizer';
import { facebookSummarizerConfig } from './facebook-summarizer';
import { tiktokTranscriptConfig } from './tiktok-transcript';

/**
 * Auto-discovery registry of all available summarizer tools
 * New tools are automatically discovered by adding their config here
 */
export const summarizerTools: ToolRegistry = {
  [youtubeSummarizerConfig.id]: youtubeSummarizerConfig,
  [videoSummarizerConfig.id]: videoSummarizerConfig,
  [pdfSummarizerConfig.id]: pdfSummarizerConfig,
  [notionSummarizerConfig.id]: notionSummarizerConfig,
  [powerpointSummarizerConfig.id]: powerpointSummarizerConfig,
  [textSummarizerConfig.id]: textSummarizerConfig,
  [googleDriveSummarizerConfig.id]: googleDriveSummarizerConfig,
  [webPageSummarizerConfig.id]: webPageSummarizerConfig,
  [audioFileSummarizerConfig.id]: audioFileSummarizerConfig,
  [podcastSummarizerConfig.id]: podcastSummarizerConfig,
  [socialMediaSummarizerConfig.id]: socialMediaSummarizerConfig,
  [facebookSummarizerConfig.id]: facebookSummarizerConfig,
  [googleDocsSummarizerConfig.id]: googleDocsSummarizerConfig,
  [twitterThreadSummarizerConfig.id]: twitterThreadSummarizerConfig,
  [tiktokTranscriptConfig.id]: tiktokTranscriptConfig,
};

/**
 * Get all available tool configurations
 */
export function getAllTools(): ToolRegistry {
  return summarizerTools;
}

/**
 * Get tool configuration by ID
 */
export function getToolById(id: string) {
  const tool = summarizerTools[id];
  return tool;
}

/**
 * Get tools by category
 */
export function getToolsByCategory(category: string) {
  return Object.values(summarizerTools).filter((tool) => tool.category === category);
}

/**
 * Get all tool IDs for dropdown options
 */
export function getToolOptions() {
  return Object.values(summarizerTools).map((tool) => ({
    value: tool.id,
    label: tool.title,
    icon: tool.ui?.icon,
    category: tool.category,
  }));
}

/**
 * Validate tool configuration
 */
export function validateToolConfig(config: any): boolean {
  return !!(config.id && config.title && config.category && config.inputs && config.api);
}

// Export individual configs for direct import
export {
  youtubeSummarizerConfig,
  pdfSummarizerConfig,
  textSummarizerConfig,
  videoSummarizerConfig,
  googleDocsSummarizerConfig,
  podcastSummarizerConfig,
  webPageSummarizerConfig,
  twitterThreadSummarizerConfig,
  powerpointSummarizerConfig,
  notionSummarizerConfig,
  googleDriveSummarizerConfig,
  audioFileSummarizerConfig,
  socialMediaSummarizerConfig,
  facebookSummarizerConfig,
  tiktokTranscriptConfig,
};
